import { Image as ImageIcon } from "@phosphor-icons/react";
import { Message } from "../../../models/Message";
import { ImageView } from "./styles";
import { FileShowModal } from "../../Modals/FileShowModal";
import { useEffect, useState } from "react";
import { User } from "../../../models/User";
import { Contact } from "../../../models/Contact";
import { useFileAccessURL } from "../../../hooks/useFileAccessURL";
import { getFileAccessReferences } from "../../../utils/fileAccessURL";
import { MessageTextContent } from "../TextContent";

export interface ImageProps {
  message: Message;
  user: User;
  contact: Contact;
};

export const Image = ({
  message,
  contact,
  user,
}: ImageProps ) => {
  const [ open, setOpen ] = useState<boolean>( false );
  const [ shouldLoadOriginal, setShouldLoadOriginal ] = useState( false );
  const previewReferences = getFileAccessReferences(message.fileMetadata, "preview", "image");
  const fallbackPreviewReference = previewReferences.find((reference) => reference !== previewReferences[0]);
  const thumbnailURL = useFileAccessURL({
    mode: "inline",
    reference: previewReferences[0],
  });
  const originalURL = useFileAccessURL({
    mode: "inline",
    reference: fallbackPreviewReference,
    enabled: shouldLoadOriginal && Boolean(fallbackPreviewReference),
  });
  const [ imageURL, setImageURL ] = useState( thumbnailURL );

  useEffect(() => {
    setImageURL( thumbnailURL );
    setShouldLoadOriginal( false );
  }, [ thumbnailURL ]);

  useEffect(() => {
    if( shouldLoadOriginal ) setImageURL( originalURL );
  }, [ originalURL, shouldLoadOriginal ]);

  return (
    <ImageView>
      <button
        type="button"
        className="thumbnail"
        aria-label={ `Abrir imagem ${ message.fileMetadata?.fileName ?? "anexada" }` }
        onClick={() => setOpen( true )}
      >
        <img
          src={ imageURL }
          alt={ message.fileMetadata?.fileName ?? "Imagem anexada" }
          onError={() => {
            if( fallbackPreviewReference && imageURL !== originalURL ) {
              setShouldLoadOriginal( true );
            }
          }}
        />

        <div className="info">
          <ImageIcon
            size={ 16 }
            weight="fill"
          />
        </div>
      </button>

      {
        message.content !== "" && (
          <MessageTextContent content={ message.content } />
        )
      }

      {
        open && (
          <FileShowModal
            message={ message }
            open={ open }
            onClose={() => setOpen( false )}
            user={ user }
            contact={ contact }
          />
        )
      }
    </ImageView>
  );
};
